import {Component, OnInit, ViewChild} from '@angular/core';
import {BarcodeFormat} from "@zxing/library";
import {ZXingScannerComponent} from "@zxing/ngx-scanner";
import {BarcodeScannerService} from "../../services/barcode-scanner.service";
import {MatDialogRef} from "@angular/material/dialog";
import {BehaviorSubject} from "rxjs";
import {TranslateService} from "@ngx-translate/core";


@Component({
  selector: 'app-scanner',
  templateUrl: './scanner.component.html',
  styleUrls: ['./scanner.component.scss']
})
export class ScannerComponent {
  title: string = this.translate.instant('scanner.title');
  @ViewChild('scanner', {static: false}) scanner: ZXingScannerComponent;
  camerasFound: boolean = false;
  torchEnabled: boolean = false;
  torchAvailable: boolean = false;
  allowedFormats: BarcodeFormat[] = [
    BarcodeFormat.CODE_128,
    BarcodeFormat.QR_CODE,
    BarcodeFormat.EAN_13
  ];

  constructor(public dialogRef: MatDialogRef<ScannerComponent>,
              public barcodeScannerService: BarcodeScannerService,
              private translate: TranslateService) {
  }

  onCamerasFound(devices: MediaDeviceInfo[]) {
    this.camerasFound = true;
  }

  onCamerasNotFound(cameraNotFound: any) {
    this.camerasFound = false;
  }

  scanSuccessHandler(barcode: string) {
    this.barcodeScannerService.scanSuccess$.emit(barcode);
    this.dialogRef.close();
 }

  onTorchCompatible(isCompatible: boolean): void {
    this.torchAvailable = isCompatible;
  }

  toggleTorch(): void {
    this.torchEnabled = !this.torchEnabled;
  }
}
